module.exports = __webpack_public_path__ + "img/fastForward.6b8e0b57.png";